import React from 'react';

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Button,
} from '@mui/material';
import { useRecoilValue } from 'recoil';
import { dashboardState } from '../../state/RecoilState';
import { FeedbackResponseListItem } from '../../@types/api';
import { useNavigate } from 'react-router-dom';

const FeedbackList = () => {
  const navigate = useNavigate();
  const dashboard = useRecoilValue(dashboardState);
  const data = dashboard?.feedbackResponses;
  if (!data || data.length === 0) return null;
  return (
    <Box sx={{ py: 1 }}>
      <Typography variant='h5'>New Feedback</Typography>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>ResponseID</TableCell>
            <TableCell>FirstName</TableCell>
            <TableCell>Surname</TableCell>
            <TableCell>Artist Name</TableCell>
            <TableCell align='right'>Annon?</TableCell>
            <TableCell align='left'>ArtistText</TableCell>
            <TableCell align='left'>ServiceText</TableCell>
            <TableCell>BookingID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row: FeedbackResponseListItem) => (
            <TableRow key={row.responseId}>
              <TableCell>
                <Button
                  size='small'
                  variant='contained'
                  color='secondary'
                  onClick={() =>
                    navigate(`/createtestimoninal/${row.responseId}`)
                  }
                >
                  {row.responseId}
                </Button>
              </TableCell>
              <TableCell>{row.firstName}</TableCell>
              <TableCell>{row.surname}</TableCell>
              <TableCell>{row.artistName}</TableCell>
              <TableCell align='right'>{row.keepAnon}</TableCell>
              <TableCell align='left'>{row.artistText}</TableCell>
              <TableCell align='left'>{row.serviceText}</TableCell>
              <TableCell>{row.bookingId}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default FeedbackList;
